"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ArweaveUtils = require("./lib/utils");

var Wallets =
/*#__PURE__*/
function () {
  function Wallets(api, crypto) {
    _classCallCheck(this, Wallets);

    this.api = api;
    this.crypto = crypto;
  }
  /**
   * Get the wallet balance for the given address.
   *
   * @param {string} address - The arweave address to get the balance for.
   *
   * @returns {Promise<string>} - Promise which resolves with a winston string balance.
   */


  _createClass(Wallets, [{
    key: "getBalance",
    value: function getBalance(address) {
      return this.api.get("wallet/".concat(address, "/balance"), {
        transformResponse: [
        /**
         * We need to specify a response transformer to override
         * the default JSON.parse behaviour, as this causes
         * balances to be converted to a number and we want to
         * return it as a winston string.
         * @param data
         */
        function (data) {
          return data;
        }]
      }).then(function (response) {
        return response.data;
      });
    }
    /**
     * Get the last transaction ID for the given wallet address.
     *
     * @param {string} address - The arweave address to get the balance for.
     *
     * @returns {Promise<string>} - Promise which resolves with a winston string balance.
     */

  }, {
    key: "getLastTransactionID",
    value: function getLastTransactionID(address) {
      return this.api.get("wallet/".concat(address, "/last_tx")).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "generate",
    value: function generate() {
      return this.crypto.generateJWK();
    }
  }, {
    key: "jwkToAddress",
    value: function () {
      var _jwkToAddress = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(jwk) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.ownerToAddress(jwk.n));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function jwkToAddress(_x) {
        return _jwkToAddress.apply(this, arguments);
      }

      return jwkToAddress;
    }()
  }, {
    key: "ownerToAddress",
    value: function () {
      var _ownerToAddress = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(owner) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = ArweaveUtils;
                _context2.next = 3;
                return this.crypto.hash(ArweaveUtils.b64UrlToBuffer(owner));

              case 3:
                _context2.t1 = _context2.sent;
                return _context2.abrupt("return", _context2.t0.bufferTob64Url.call(_context2.t0, _context2.t1));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function ownerToAddress(_x2) {
        return _ownerToAddress.apply(this, arguments);
      }

      return ownerToAddress;
    }()
  }]);

  return Wallets;
}();

exports.default = Wallets;